import { DataType } from '@/util/index'
import SystemEnum from '@/assets/js/systemEnum'
const WORK_QUEUE = SystemEnum.WORK_QUEUE_ENUM
const QUEUE = [
  {
    status: WORK_QUEUE.APPROVED.value,
    title: WORK_QUEUE.APPROVED.text,
    key: WORK_QUEUE.APPROVED.key,
    features: WORK_QUEUE.APPROVED.features,
    color: ['#5C82E3', '#F2F5FD'],
    code: DataType.PrivilegeCode.APPROVED_QUEUE,
    config: {
      displayApplicationStatus: true
    },
    count: 0,
    items: [],
    indexOfPage: 1,
    isEnd: true,
    isLoading: true
  },
  {
    status: WORK_QUEUE.NEW_LOAN.value,
    title: WORK_QUEUE.NEW_LOAN.text,
    key: WORK_QUEUE.NEW_LOAN.key,
    features: WORK_QUEUE.NEW_LOAN.features,
    color: ['#5BCDF2', '#F2FBFE'],
    code: DataType.PrivilegeCode.NEW_QUEUE,
    count: 0,
    items: [],
    indexOfPage: 1,
    isEnd: true,
    isLoading: true
  },
  {
    status: WORK_QUEUE.GOOD_STANDING.value,
    title: WORK_QUEUE.GOOD_STANDING.text,
    key: WORK_QUEUE.GOOD_STANDING.key,
    features: WORK_QUEUE.GOOD_STANDING.features,
    color: ['#EAA0C8', '#FEFAFC'],
    code: DataType.PrivilegeCode.GOOD_STANDING_QUEUE,
    config: {
      displayNotes: true
    },
    count: 0,
    items: [],
    indexOfPage: 1,
    isEnd: true,
    isLoading: true
  },
  {
    status: WORK_QUEUE.WARNING.value,
    title: WORK_QUEUE.WARNING.text,
    key: WORK_QUEUE.WARNING.key,
    features: WORK_QUEUE.WARNING.features,
    color: ['#F37070', '#FFF4F4'],
    code: DataType.PrivilegeCode.WARNING_QUEUE,
    count: 0,
    items: [],
    indexOfPage: 1,
    isEnd: true,
    isLoading: true
  },
  {
    status: WORK_QUEUE.PAID_OFF.value,
    title: WORK_QUEUE.PAID_OFF.text,
    key: WORK_QUEUE.PAID_OFF.key,
    features: WORK_QUEUE.PAID_OFF.features,
    color: ['#F67E9B', '#FFF5F8'],
    code: DataType.PrivilegeCode.PAID_OFF_QUEUE,
    config: {
      displayApplicationStatus: true
    },
    count: 0,
    items: [],
    indexOfPage: 1,
    isEnd: true,
    isLoading: true,
    iconItem: {
      icon: 'open_in_new',
      tooltip: 'Export',
      code: DataType.PrivilegeCode.PAID_OFF_EXPORT
    }
  },
  {
    status: WORK_QUEUE.VOIDED_LOAN.value,
    title: WORK_QUEUE.VOIDED_LOAN.text,
    key: WORK_QUEUE.VOIDED_LOAN.key,
    features: WORK_QUEUE.VOIDED_LOAN.features,
    color: ['#FF843F', '#FFF7F2'],
    code: DataType.PrivilegeCode.VOIDED_QUEUE,
    config: {
      displayApplicationStatus: true
    },
    count: 0,
    items: [],
    indexOfPage: 1,
    isEnd: true,
    isLoading: true
  },
  {
    status: WORK_QUEUE.PENDING_APPROVED.value,
    title: WORK_QUEUE.PENDING_APPROVED.text,
    key: WORK_QUEUE.PENDING_APPROVED.key,
    features: WORK_QUEUE.PENDING_APPROVED.features,
    color: ['#64CA99', '#EFFFF7'],
    code: DataType.PrivilegeCode.PENDING_APPROVED_QUEUE,
    config: {
      displayApplicationStatus: true
    },
    count: 0,
    items: [],
    indexOfPage: 1,
    isEnd: true,
    isLoading: true
  }
]

const SPECIAL_QUEUE = [
  {
    status: WORK_QUEUE.NEW_LOAN.value,
    title: WORK_QUEUE.NEW_LOAN.text,
    key: WORK_QUEUE.NEW_LOAN.key,
    features: WORK_QUEUE.NEW_LOAN.features,
    color: ['#5BCDF2', '#F2FBFE'],
    code: DataType.PrivilegeCode.NEW_QUEUE,
    count: 0,
    items: [],
    indexOfPage: 1,
    isEnd: true,
    isLoading: true
  },
  {
    status: WORK_QUEUE.GOOD_STANDING.value,
    title: WORK_QUEUE.GOOD_STANDING.text,
    key: WORK_QUEUE.GOOD_STANDING.key,
    features: WORK_QUEUE.GOOD_STANDING.features,
    color: ['#EAA0C8', '#FEFAFC'],
    code: DataType.PrivilegeCode.GOOD_STANDING_QUEUE,
    config: {
      displayNotes: true
    },
    count: 0,
    items: [],
    indexOfPage: 1,
    isEnd: true,
    isLoading: true
  },
  {
    status: WORK_QUEUE.PROCESSING.value,
    title: WORK_QUEUE.PROCESSING.text,
    key: WORK_QUEUE.PROCESSING.key,
    features: WORK_QUEUE.PROCESSING.features,
    color: ['#685DE8', '#F3F2FD'],
    code: DataType.PrivilegeCode.PROCESSING_QUEUE,
    count: 0,
    items: [],
    indexOfPage: 1,
    isEnd: true,
    isLoading: true
  },
  {
    status: WORK_QUEUE.WARNING.value,
    title: WORK_QUEUE.WARNING.text,
    key: WORK_QUEUE.WARNING.key,
    features: WORK_QUEUE.WARNING.features,
    color: ['#F37070', '#FFF4F4'],
    code: DataType.PrivilegeCode.WARNING_QUEUE,
    count: 0,
    items: [],
    indexOfPage: 1,
    isEnd: true,
    isLoading: true
  },
  {
    status: WORK_QUEUE.VOIDED_LOAN.value,
    title: WORK_QUEUE.VOIDED_LOAN.text,
    key: WORK_QUEUE.VOIDED_LOAN.key,
    features: WORK_QUEUE.VOIDED_LOAN.features,
    color: ['#FF843F', '#FFF7F2'],
    code: DataType.PrivilegeCode.VOIDED_QUEUE,
    config: {
      displayApplicationStatus: true
    },
    count: 0,
    items: [],
    indexOfPage: 1,
    isEnd: true,
    isLoading: true
  },
  {
    status: WORK_QUEUE.PENDING_APPROVED.value,
    title: WORK_QUEUE.PENDING_APPROVED.text,
    key: WORK_QUEUE.PENDING_APPROVED.key,
    features: WORK_QUEUE.PENDING_APPROVED.features,
    color: ['#64CA99', '#EFFFF7'],
    code: DataType.PrivilegeCode.PENDING_APPROVED_QUEUE,
    config: {
      displayApplicationStatus: true
    },
    count: 0,
    items: [],
    indexOfPage: 1,
    isEnd: true,
    isLoading: true
  }
]
const TO_BE_CONFIRMED_QUEUE = [
  {
    color: ['#f79b22', '#F2F5FD'],
    count: 0,
    indexOfPage: 1,
    isEnd: true,
    isLoading: true,
    items: [],
    key: 'unknownCreditStatus',
    status: 40011,
    title: 'Unknown Credit Status'
  },
  {
    color: ['#f79b22', '#F2F5FD'],
    count: 0,
    indexOfPage: 1,
    isEnd: true,
    isLoading: true,
    items: [],
    key: 'suspectedMLA',
    status: 40012,
    title: 'Suspected MLA'
  }
]
export { QUEUE, SPECIAL_QUEUE, TO_BE_CONFIRMED_QUEUE }
